
export function constifyString(text) {
  return text.toString().toUpperCase()
    .replace(/\s+/g, '_')        // Replace spaces with _
    .replace(/[^\w_]+/g, '')     // Remove all non-word chars
    .replace(/__+/g, '_')        // Replace multiple _ with single _
    .replace(/^_+/, '')          // Trim _ from start of text
    .replace(/_+$/, '');         // Trim _ from end of text
}

export function camelifyString(str) {
  return constifyString(str).toLowerCase().replace(/[-_]([a-z])/g, function (g) { return g[1].toUpperCase(); })
}

export function guidGenerator() {
    var S4 = function() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}



// WEBPACK FOOTER //
// ./src/service/UtilService.js